"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./create-crm-promocode.dto"), exports);
__exportStar(require("./create-promocode.dto"), exports);
__exportStar(require("./crm-promocode.dto"), exports);
__exportStar(require("./crm-promocodes-page-args.dto"), exports);
__exportStar(require("./crm-promocodes-page.dto"), exports);
__exportStar(require("./get-promocodes-list.dto"), exports);
__exportStar(require("./promocode-condition-values.dto"), exports);
__exportStar(require("./promocode-discount-product-type-logic-value.dto"), exports);
__exportStar(require("./promocode-logic-value.dto"), exports);
__exportStar(require("./promocode-product-in-cart-condition-values.dto"), exports);
__exportStar(require("./promocode-quantity-and-netto-total-greater-condition-values.dto"), exports);
__exportStar(require("./promocode.dto"), exports);
__exportStar(require("./update-promocode.dto"), exports);
//# sourceMappingURL=index.js.map